import React, { FC, useEffect } from "react"
import Modal from "@mui/material/Modal"
import Backdrop from "@mui/material/Backdrop"
import Fade from "@mui/material/Fade"
import { IconButton } from "./IconButton"
import { Box } from "@mui/system"
import theme from "../../material-ui/theme"

interface ModalProps {
  id?: string
  isOpen: boolean
  setIsOpen: Function
  title?: string
  text?: string
  children?: JSX.Element
  darkMode?: boolean
  wide?: boolean
  maxWidth?: string
  padding?: string
  gradientTitle?: boolean
}

const TransitionsModal: FC<ModalProps> = ({
  id,
  isOpen,
  title,
  text,
  children,
  setIsOpen,
  darkMode,
  wide,
  maxWidth,
  padding,
  gradientTitle,
}) => {
  const classes = {
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    paper: {
      backgroundColor: theme.palette.background.paper,
      border: "2px solid var(--color-teal)",
      borderRadius: "10px",
      boxShadow: theme.shadows[5],
      padding: padding
        ? padding
        : wide
        ? theme.spacing(4, 2)
        : theme.spacing(4, 5, 4),
      position: "relative",
      maxHeight: "95vh",
      maxWidth: maxWidth ? maxWidth : "auto",
      width: maxWidth ? maxWidth : undefined,
      overflowY: "auto",
      overflowX: "hidden",
      "&:focus": {
        outline: "none",
      },
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
    paperDark: {
      backgroundColor: "transparent",
      border: "none",
      padding: theme.spacing(4, 5, 4),
      position: "relative",
      maxHeight: "95vh",
      overflowY: "auto",
      "&:focus": {
        outline: "none",
      },
    },

    icon: {
      position: "absolute",
      right: "0.5rem",
      top: "0.5rem",
      fontSize: "1rem",
      zIndex: 3,
    },
    iconDark: {
      position: "fixed",
      right: "1rem",
      top: "1rem",
      fontSize: "1rem",
      zIndex: 3,
    },
  }

  const [open, setOpen] = React.useState(isOpen)

  const handleClose = () => {
    setIsOpen(false)
  }

  useEffect(() => {
    setOpen(isOpen)
  }, [isOpen, title, text])

  return (
    <div>
      <Modal
        id={id}
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        sx={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
          style: darkMode ? { backgroundColor: "rgba(0,0,0,0.9)" } : {},
        }}
      >
        <Fade in={open} timeout={{ appear: 1000, exit: 1000 }}>
          <Box sx={darkMode ? classes.paperDark : classes.paper}>
            <Box
              id="close-modal"
              sx={darkMode ? classes.iconDark : classes.icon}
            >
              <IconButton
                aria-label="close"
                size="xs"
                iconColor={darkMode ? "#AAA" : "#AAA"}
                icon="times"
                onClick={handleClose}
              />
            </Box>

            {title && (
              <h3
                id="transition-modal-title"
                className={gradientTitle ? "gradientText" : ""}
              >
                {title}
              </h3>
            )}
            {text && <p id="transition-modal-description">{text}</p>}
            {children}
          </Box>
        </Fade>
      </Modal>
    </div>
  )
}

export default TransitionsModal
